import React, { useEffect, useState, useMemo } from 'react';
import axios from 'axios';
import config from "../config/default.json";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTournament } from './TournamentContext';
import { faRankingStar } from '@fortawesome/free-solid-svg-icons';

const base_url = config.base_url;

const Standings = () => {
  const [teams, setTeams] = useState([]);
  const [sortConfig, setSortConfig] = useState({ key: 'standing', direction: 'ascending' });
  const { tournamentID } = useTournament();

  useEffect(() => {
    if (tournamentID) {
      fetchTeams();
      const interval = setInterval(fetchTeams, 10000);
      return () => clearInterval(interval);
    }
  }, [tournamentID]);

  const fetchTeams = async () => {
    try {
      const response = await axios.get(`${base_url}/api/teams/${tournamentID}`);
       const sorted = response.data.sort((a, b) => {
      if (a.standing === 0 && b.standing !== 0) return 1;   // push a down
      if (b.standing === 0 && a.standing !== 0) return -1;  // push b down
      return a.standing - b.standing; // normal ascending
    });
      setTeams(sorted);
    } catch (error) {
      console.error(error);
    }
  };

  const getValue = (obj, path) =>
    path.split('.').reduce((acc, part) => acc && acc[part], obj);


  
  const sortedTeams = useMemo(() => {
  const sortable = [...teams];
  if (sortConfig?.key) {
    sortable.sort((a, b) => {
      const aVal = getValue(a, sortConfig.key);
      const bVal = getValue(b, sortConfig.key);

       if (sortConfig.key === 'standing') {
        if (a.standing === 0 && b.standing !== 0) return 1;
        if (b.standing === 0 && a.standing !== 0) return -1;
      }

      let primaryComparison;
      if (typeof aVal === 'string' && typeof bVal === 'string') {
        primaryComparison = sortConfig.direction === 'ascending'
          ? aVal.localeCompare(bVal)
          : bVal.localeCompare(aVal);
      } else {
        primaryComparison = sortConfig.direction === 'ascending'
          ? (aVal ?? 0) - (bVal ?? 0)
          : (bVal ?? 0) - (aVal ?? 0);
      }

      // If values are equal and primary sort is not 'standing', sort by standing as fallback
      if (primaryComparison === 0 && sortConfig.key !== 'standing') {
        return a.standing - b.standing; // always ascending for secondary rank
      }

      return primaryComparison;
    });
  }
  return sortable;
}, [teams, sortConfig]);


  const requestSort = (key) => {
    let direction = 'ascending';
    if (sortConfig.key === key && sortConfig.direction === 'ascending') {
      direction = 'descending';
    }
    setSortConfig({ key, direction });
  };

  const getSortSymbol = (key) => {
    if (sortConfig.key === key) {
      return sortConfig.direction === 'ascending' ? ' ▲' : ' ▼';
    }
    return '';
  };

  return (
    <div>
      <h1>
        <FontAwesomeIcon icon={faRankingStar} /> &nbsp;Standings
      </h1>
     <p>Click on the header to change the sort order</p>
      <div className="card-container">
        <div className="card">
          <table>
            <thead>
              <tr>
                <th onClick={() => requestSort('standing')}>Rank{getSortSymbol('standing')}</th>
                <th onClick={() => requestSort('name')}>Name{getSortSymbol('name')}</th>
                <th onClick={() => requestSort('division.name')}>Division{getSortSymbol('division.name')}</th>
                <th onClick={() => requestSort('totalGamesPlayed')}>P{getSortSymbol('totalGamesPlayed')}</th>
                <th onClick={() => requestSort('totalWins')}>W{getSortSymbol('totalWins')}</th>
                <th onClick={() => requestSort('totalLosses')}>L{getSortSymbol('totalLosses')}</th>
              </tr>
            </thead>
            <tbody>
              {sortedTeams.map((team) => (
                <tr key={team._id}>
                  <td>{team.standing}</td>
                  <td>{team.name}</td>
                  <td>{team.division?.name || '-'}</td>
                  <td>{team.totalGamesPlayed}</td>
                  <td>{team.totalWins}</td>
                  <td>{team.totalLosses}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default Standings;
